module.exports = __webpack_public_path__ + "static/img/person-1205346_960_720.043e35d3.png";